import { Button } from "@chakra-ui/react";
import React from "react";
import { Link as ReactLink } from "react-router-dom";

export default class NavButton extends React.Component<{ to: string, colorScheme?: string, text: string, isDisabled?: boolean }> {
        render() {
            return (
                <ReactLink to={this.props.to}>
                    <Button colorScheme={this.props.colorScheme} isDisabled={this.props.isDisabled}>
                        {this.props.text}
                    </Button>
                </ReactLink>
            );
        }
    }